import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacyPage">
      <div className="privacyContainer">
        <h1 className="privacyTitle">Privacy Policy for German A1-C2</h1>

        <p>
          German A1-C2 (“we”, “us”, or “our”) is committed to protecting your
          privacy. This Privacy Policy explains how information may be handled
          when you use the German A1-C2 app (“App”).
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We do not require you to create an account in order to use the App,
          and we do not directly ask you to provide personal information such as
          your name, postal address, or phone number to use the core learning
          features.
        </p>
        <p>
          However, the App uses third-party services for subscriptions,
          purchases, and advertising. These services may process certain data
          automatically in order to provide their functionality.
        </p>

        <h2>2. Third-Party Services</h2>
        <p>The App may use third-party services such as:</p>
        <p>
          • Apple App Store / StoreKit for iOS subscriptions and purchases
          <br />
          • Google Play Billing for Android subscriptions and purchases
          <br />
          • RevenueCat for subscription management and purchase status
          <br />• Third-party advertising providers for ads shown to free users
        </p>
        <p>
          These services may process information such as device information, app
          version, purchase status, identifiers, IP address, approximate
          location, diagnostics, and ad-related data, depending on the platform,
          region, and service used.
        </p>

        <h2>3. How Information Is Used</h2>
        <p>
          Information processed by the App or its service providers may be used
          to:
        </p>
        <p>
          • provide and restore premium access
          <br />
          • process subscriptions and purchases
          <br />
          • display advertisements to free users
          <br />
          • prevent fraud and abuse
          <br />• maintain security, functionality, and reliability
        </p>

        <h2>4. Advertising</h2>
        <p>
          Free users may see advertisements in the App. Ads may be provided by
          third-party ad networks. Those providers may process data required to
          deliver, measure, and improve ads in accordance with their own privacy
          policies and applicable laws.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We do not maintain user account profiles within the App. However,
          third-party services used for subscriptions, billing, diagnostics, or
          advertising may retain data for as long as needed to provide their
          services, comply with legal obligations, resolve disputes, or enforce
          their agreements.
        </p>

        <h2>6. Your Choices</h2>
        <p>
          Subscription management, cancellation, and billing are handled through
          the platform from which you subscribed, such as Apple App Store or
          Google Play. Depending on your device, platform, and region, you may
          also be offered choices related to personalized advertising or
          tracking permissions.
        </p>

        <h2>7. Children’s Privacy</h2>
        <p>
          The App is intended for general audiences. We do not knowingly collect
          personal information directly from children through account
          registration or similar features. If you believe personal information
          has been provided to us inappropriately, please contact us.
        </p>

        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. When we do, we
          will post the updated version on this page. Your continued use of the
          App after changes become effective means you accept the revised
          Privacy Policy.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at <a href="mailto:kugathaj@gmail.com">kugathaj@gmail.com</a>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
